<template>
  <div class="position-relative mb-3 w-100">
    <div
      :class="['text-editor-custom', { error: isValidate }]"
      :id="'container-texteditor-' + name"
    >
      <div class="content-between" v-if="textFloat">
        <label>
          {{ textFloat }}
          <span v-if="isRequired" class="text-error">*</span>
          <slot name="label-action"></slot>
        </label>
      </div>

      <OtherLoading v-if="isLoading" />

      <template v-if="display">
        <textarea
          v-show="isLoading"
          :id="'texteditor-' + name"
          v-model="editContent"
          :ref="'texteditor-' + name"
        >
&lt;p&gt;Initial Document Content&lt;/p&gt;
        </textarea>
        <slot />

        <TicketTemplate
          :ref="name"
          v-if="showTemplate"
          @selectTemplate="selectTemplate"
          @onAddFileAttachment="addFileAttachment"
          :templateId="templateId"
          :addFile="addFile"
        />
      </template>

      <div v-else class="card card-preview-editor p-3">
        <div class="edit-detail" @click="showEditor">
          <font-awesome-icon icon="pencil-alt" />
        </div>
        <div v-html="value" v-if="value"></div>
        <div v-else class="content-empty">No Information</div>
      </div>
    </div>

    <img :src="img" alt="logo-lang" v-if="img" class="logo-lang" />
    <div v-if="v && v.$error" class="mt-1">
      <span class="text-error" v-if="v.required == false"
        >Please fill out.</span
      >
    </div>
  </div>
</template>

<script>
import TicketTemplate from "@/components/ticket/TicketTemplate";
import OtherLoading from "@/components/loading/OtherLoading";
export default {
  name: "text-editor-free",
  components: { OtherLoading, TicketTemplate },
  props: {
    textFloat: { required: true, type: String },
    placeholder: { required: true, type: String },
    required: { required: false, type: Boolean },
    isRequired: { required: false, type: Boolean },
    pattern: { required: false, type: String },
    detail: { required: false, type: String },
    name: { required: false, type: String, default: "editor" },
    value: { required: false, type: String },
    isDisplay: { required: false, type: Boolean },
    rows: { required: false, type: Number },
    isValidate: { required: false, type: Boolean },
    maxLength: { required: false, type: Number },
    img: { required: false, type: String },
    v: { required: false, type: Object },
    defaultEdit: { required: false, type: Boolean, default: true },
    showTemplate: { required: false, type: Boolean, default: false },
    variables: { required: false, type: Array, default: () => [] },
    addFile: { required: false, type: Boolean, default: false },
    useQuoteProtect: { required: false, type: Boolean, default: false },
    toolbar: {
      required: false,
      default:
        "{bold,italic,underline,strike,superscript,subscript}|{fontname,fontsize}|{forecolor,backcolor}|{justifyleft,justifycenter,justifyright,justifyfull}|{indent,outdent,insertblockquote}|{insertorderedlist,insertunorderedlist,inserthorizontalrule,insertdate}|{code,fullscreenenter,fullscreenexit,selectall,newdoc}|{undo,redo,insertlink,insertchars,inserttable,insertimage,insertcode}",
    },
    toolbar: {
      required: false,
      default:
        "{bold,italic,underline,strike,superscript,subscript}|{fontname,fontsize}|{forecolor,backcolor}|{justifyleft,justifycenter,justifyright,justifyfull}|{indent,outdent,insertblockquote}|{insertorderedlist,insertunorderedlist,inserthorizontalrule,insertdate}|{code,fullscreenenter,fullscreenexit,selectall,newdoc,save}|{undo,redo,insertlink,insertchars,inserttable,insertimage,insertcode,html2pdf,print,preview,find}",
    },
  },
  data() {
    return {
      editContent: "",
      editor: null,
      id: this.$route.params.id,
      isEdit: false,
      isLoading: false,
      templateId: 0,
      isHTMLView: false,
    };
  },
  watch: {
    editContent(value) {
      return this.$emit("onDataChange", value);
    },
    async value(val) {
      this.editContent = val;
      return val;
    },
  },
  computed: {
    display() {
      if (this.defaultEdit) return this.isEdit;
      if (isNaN(this.id)) return true;
      if (!this.defaultEdit) return true;
      return !this.id || this.id == 0 || this.isEdit;
    },
  },
  created() {
    this.editContent = this.value;
  },
  async mounted() {
    if (this.display) this.initEditor();
    this.$forceUpdate();
  },
  methods: {
    observeHTMLView() {
      let docu = document.getElementById("container-texteditor-" + this.name);
      const observer = new MutationObserver(() => {
        const textarea = this.$el.querySelector("rte-codebox textarea");
        if (textarea) {
          textarea.addEventListener("input", () => {
            this.$emit("onDataChange", this.editor.getHTMLCode());
          });
        }
        this.isHTMLView = document.querySelector("rte-codebox") !== null;
      });
      if (docu) {
        observer.observe(docu, { childList: true, subtree: true });
      }
    },
    async loadExternalResources() {
      if (window.RichTextEditor) return Promise.resolve();
      const loadScript = (src) =>
        new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = src;
          script.async = true;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      const loadStyle = (href) =>
        new Promise((resolve, reject) => {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = href;
          link.onload = resolve;
          link.onerror = reject;
          document.head.appendChild(link);
        });
      const version = Date.now();
      return loadStyle(`/richtexteditor/rte_theme_default.css?v=${version}`)
        .then(() => loadScript(`/richtexteditor/rte.js?v=${version}`))
        .then(() =>
          loadScript(`/richtexteditor/plugins/all_plugins.js?v=${version}`)
        );
    },
    async initEditor() {
      this.isLoading = true;
      await this.loadExternalResources();
      var config = { id: `texteditor-${this.name}` };
      const $ = this;
      function convertFileToBase64(file, callback) {
        const reader = new FileReader();
        reader.onloadend = function () {
          const base64String = reader.result;
          callback(base64String);
        };
        reader.onerror = function (error) {
          console.error("Error reading file:", error);
        };
        reader.readAsDataURL(file);
      }
      config.file_upload_handler = function (file, callback) {
        var uploadhandlerpath = `/News/UploadImage`;
        const controller = new AbortController();
        const signal = controller.signal;
        convertFileToBase64(file, function (base64String) {
          function detectMimeType(b64) {
            return b64.indexOf("image/png") != -1 ? 1 : 0;
          }
          let payload = {
            type: detectMimeType(base64String),
            Base64String: base64String,
          };
          $.axios
            .post(uploadhandlerpath, payload, { signal })
            .then((response) => {
              callback(response.data.detail);
            })
            .catch((error) => {
              if (error.response) {
                callback(null, "http-error-" + error.response.status);
              } else {
                callback(null, error.message);
              }
            });
        });
      };
      config.toolbarfactory_myselect = function () {
        if ($.variables.length == 1) {
          var btn = document.createElement("button");
          btn.style.cssText =
            "background-color:transparent;color: #333;border: 1px solid transparent;border-radius: 4px;padding: 4px 8px;font-size: 14px;font-family: inherit";
          btn.innerHTML = $.variables[0];
          btn.onclick = function () {
            if ($.variables[0] == "conversation_url")
              return editor.insertHTML(
                `<a href="{{${$.variables[0]}}}" target="_blank">Conversation URL</a>`
              );
            editor.insertHTML(`{{${$.variables[0]}}}`);
          };
          return btn;
        } else {
          var sel = document.createElement("select");
          sel.style.cssText =
            "color: #333;border: 1px solid #d8dbe0;border-radius: 4px;padding: 4px 8px;font-size: 14px;font-family: inherit";
          function addOption(text, value) {
            var option = document.createElement("option");
            option.innerText = text;
            option.setAttribute("value", value);
            option.rawValue = value;
            sel.appendChild(option);
          }
          addOption("Variables");
          for (const element of $.variables) addOption(element, element);
          sel.onclick = function (e) {
            e.stopPropagation();
          };
          sel.onchange = function () {
            var option = sel.options[sel.selectedIndex];
            var val = option.rawValue;
            sel.selectedIndex = 0;
            editor.insertHTML(`{{${val}}}`);
          };
          return sel;
        }
      };
      config.toolbar = "default";
      config.toolbar_default = this.toolbar;
      if (this.variables.length > 0) config.toolbar_default += "{myselect}";
      const editor = await new window.RichTextEditor(
        `#texteditor-${this.name}`,
        {
          ...config,
          editorResizeMode: "height",
          height: "400px",
          minHeight: "300px",
          maxHeight: "600px",

          enterKeyTag: "br",
        }
      );
      this.editor = editor;
      editor.attachEvent("change", function (event) {
        $.$emit("onDataChange", editor.getHTMLCode(), event);
      });
      let cleaning = false;
      editor.attachEvent("keyup", function (e) {
        if (cleaning) return;
        if (e.key === "Enter" && !e.shiftKey) {
          cleaning = true;

          const html = editor.getHTMLCode();
          const normalized = html
            // 1) ถ้าท้ายสุดเป็น <br> ติดกัน >= 2 ตัว (ไม่มี tag ตามหลัง) ให้เหลือ <br> เดียว
            .replace(/(<br\s*\/?>\s*){2,}\s*$/i, "<br>")
            // 2) ถ้าท้ายสุดเป็น ...<br><br></p> ให้เหลือ ...<br></p>
            .replace(/(<br\s*\/?>\s*){2,}\s*(<\/p>\s*)$/i, "<br>$2")
            // (อ็อปชัน) กันเคส ...<br></div> ให้ตัด <br> ทิ้ง
            .replace(/(<br\s*\/?>\s*)+(<\/div>\s*)$/gi, "$2");

          // if (normalized !== html) this.editor.setHTMLCode(normalized);

          cleaning = false;
          $.$emit("onDataChange", editor.getHTMLCode(), e);
        }
      });
      if (this.useQuoteProtect) this._injectQuotePreviewStyle();
      this.observeHTMLView();
      this.isLoading = false;
      this.$nextTick(() => {
        const host = this.$el.querySelector(
          "#container-texteditor-" + this.name
        );
        this.editor.focus();
        if (this.useQuoteProtect) {
          this.bindRteProtectors(host);
          this.ensureGuardsAroundAll();
          this.placeCaretAtGuard();
        }
      });
    },
    showEditor() {
      this.isEdit = true;
      this.$nextTick(() => {
        this.initEditor();
      });
    },
    onDataChange(val) {
      this.$emit("onDataChange", val);
    },
    async selectTemplate(val) {
      this.templateId = val.id;
      await this.editor.setHTMLCode(val.detail);
      this.$emit("onDataChange", val.detail);
      this.editor.selectDoc(true);
      this.editor.focus();
      this.$nextTick(() => {
        const host = this.$el.querySelector(
          "#container-texteditor-" + this.name
        );
        if (this.useQuoteProtect) this.bindRteProtectors(host);
      });
    },
    addFileAttachment(list) {
      this.$emit("addFileAttachment", list);
    },
    clearFileAttachment() {
      this.$refs[this.name].clearFile();
    },
    toggleHTMLView() {
      if (!this.isHTMLView) {
        this.showHTMLSourceView();
      } else {
        this.showWYSIWYG();
      }
    },
    updateModalValue(value) {
      this.editor?.setHTMLCode(value || "");
    },
    clearEditor() {
      this.editor?.setHTMLCode("");
      this.$emit("onDataChange", "");
    },
    getEditor() {
      return this.editor;
    },
    _injectQuotePreviewStyle() {
      if (!this.editor) return;
      const html = this.editor.getHTMLCode();
      const doc = new DOMParser().parseFromString(html, "text/html");
      if (!doc.querySelector("style[data-rte-quote-preview]")) {
        const style = doc.createElement("style");
        style.setAttribute("data-rte-quote-preview", "true");
        style.textContent = `.gmail_quote blockquote{display:none !important;}
        .gmail_quote hr{display:none !important;}`;
        doc.body.prepend(style);
        this.editor.setHTMLCode(doc.body.innerHTML);
      }
    },
    getEditorContentRoot(hostEl) {
      if (!hostEl) return null;
      const iframe = hostEl.querySelector("iframe");
      if (iframe && iframe.contentDocument && iframe.contentDocument.body)
        return iframe.contentDocument.body;
      return (
        hostEl.querySelector('[contenteditable="true"]') ||
        hostEl.querySelector(".richtexteditor") ||
        hostEl
      );
    },
    onKeyDownGuard(e) {
      const root = this._rteContentRoot;
      if (!root) return;
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "a") {
        e.preventDefault();
        this.selectAllBeforeGuard();
        return;
      }
      if (e.key === "ArrowDown" || e.key === "Enter") {
        const { sel } = this._getDocAndSel();
        if (sel && sel.anchorNode && this._isAfterGuardAfter(sel.anchorNode)) {
          e.preventDefault();
          this.placeCaretAtGuard();
          return;
        }
      }
      if (e.key !== "Backspace" && e.key !== "Delete") return;
      const doc = root.ownerDocument || document;
      const sel = doc.getSelection();
      if (!sel || !sel.rangeCount) return;
      const range = sel.getRangeAt(0);
      for (const n of root.querySelectorAll(
        ".protected-quote, .rte-guard-after"
      )) {
        if (range.intersectsNode(n)) {
          e.preventDefault();
          this.placeCaretAtGuard();
          return;
        }
      }
      if (e.key === "Backspace" && range.collapsed && range.startOffset === 0) {
        e.preventDefault();
        this.placeCaretAtGuard();
      }
    },
    startRteWatchdog() {
      const root = this._rteContentRoot;
      if (!root) return;
      if (this._rteMo)
        try {
          this._rteMo.disconnect();
        } catch (e) {}
      this._rteMo = new MutationObserver((mutations) => {
        let needEnsure = false,
          guardMaybeGone = false;
        for (const m of mutations) {
          for (const n of m.removedNodes || []) {
            if (n.nodeType !== 1) continue;
            if (n.classList.contains("protected-quote")) needEnsure = true;
            if (n.classList.contains("rte-guard")) guardMaybeGone = true;
          }
        }
        if (needEnsure) this.ensureGuardsAroundAll();
        if (
          guardMaybeGone ||
          !this._rteContentRoot.querySelector(".rte-guard")
        ) {
          this.ensureStandaloneGuard();
        }
      });
      this._rteMo.observe(root, { childList: true, subtree: true });
      this.ensureGuardsAroundAll();
    },
    bindRteProtectors(hostEl) {
      const root = this.getEditorContentRoot(hostEl);
      if (!root) return;
      this._rteContentRoot = root;
      if (!this._rteKeydownBound) {
        root.addEventListener("keydown", this.onKeyDownGuard, true);
        this._rteKeydownBound = true;
      }
      const doc = root.ownerDocument || document;
      if (!this._rteSelBound) {
        this._selHandler = this._onSelectionChangeBounce.bind(this);
        doc.addEventListener("selectionchange", this._selHandler, true);
        this._mouseUpHandler = () => this._onSelectionChangeBounce();
        doc.addEventListener("mouseup", this._mouseUpHandler, true);
        this._rteSelBound = true;
      }
      this.startRteWatchdog();
    },
    unBindRteProtectors() {
      if (this._rteContentRoot && this._rteKeydownBound) {
        this._rteContentRoot.removeEventListener(
          "keydown",
          this.onKeyDownGuard,
          true
        );
        this._rteKeydownBound = false;
      }
      const doc =
        (this._rteContentRoot &&
          (this._rteContentRoot.ownerDocument || document)) ||
        document;
      if (this._rteSelBound) {
        if (this._selHandler)
          doc.removeEventListener("selectionchange", this._selHandler, true);
        if (this._mouseUpHandler)
          doc.removeEventListener("mouseup", this._mouseUpHandler, true);
        this._selHandler = null;
        this._mouseUpHandler = null;
        this._rteSelBound = false;
      }
      if (this._rteMo) {
        try {
          this._rteMo.disconnect();
        } catch (e) {}
        this._rteMo = null;
      }
      this._rteContentRoot = null;
    },
    createGuardBefore(doc) {
      const p = doc.createElement("p");
      p.className = "rte-guard";
      const span = doc.createElement("span");
      span.setAttribute("data-rte-keeper", "1");
      span.setAttribute("contenteditable", "false");
      span.setAttribute("aria-hidden", "true");
      span.textContent = "\uFEFF";
      p.appendChild(span);
      return p;
    },
    createGuardAfter(doc) {
      const p = doc.createElement("p");
      p.className = "rte-guard-after";
      p.setAttribute("contenteditable", "false");
      p.setAttribute("aria-hidden", "true");
      const span = doc.createElement("span");
      span.setAttribute("data-rte-keeper", "1");
      span.setAttribute("contenteditable", "false");
      span.setAttribute("aria-hidden", "true");
      span.textContent = "\uFEFF";
      p.appendChild(span);
      return p;
    },
    ensureGuardsAroundAll() {
      const root = this._rteContentRoot;
      if (!root) return;
      const doc = root.ownerDocument || document;
      root.querySelectorAll(".protected-quote").forEach((q) => {
        let prev = q.previousElementSibling;
        if (!(prev && prev.classList && prev.classList.contains("rte-guard"))) {
          q.parentNode.insertBefore(this.createGuardBefore(doc), q);
        }
        let next = q.nextElementSibling;
        if (
          !(
            next &&
            next.classList &&
            next.classList.contains("rte-guard-after")
          )
        ) {
          q.parentNode.insertBefore(this.createGuardAfter(doc), q.nextSibling);
        }
      });
      root
        .querySelectorAll(
          ".rte-guard [data-rte-keeper], .rte-guard-after [data-rte-keeper]"
        )
        .forEach((s) => {
          s.setAttribute("contenteditable", "false");
          s.setAttribute("aria-hidden", "true");
        });
    },
    ensureStandaloneGuard() {
      const root = this._rteContentRoot;
      if (!root) return;
      if (!root.querySelector(".rte-guard")) {
        const doc = root.ownerDocument || document;
        const p = doc.createElement("p");
        p.className = "rte-guard";
        const span = doc.createElement("span");
        span.setAttribute("data-rte-keeper", "1");
        span.setAttribute("contenteditable", "false");
        span.setAttribute("aria-hidden", "true");
        span.textContent = "\uFEFF";
        p.appendChild(span);
        root.insertBefore(p, root.firstChild || null);
      }
    },
    getGuard() {
      const root = this._rteContentRoot;
      if (!root) return null;
      return root.querySelector(".rte-guard");
    },
    placeCaretAtGuard() {
      const root = this._rteContentRoot;
      if (!root) return;
      const guard = this.getGuard && this.getGuard();
      const doc = (root && (root.ownerDocument || document)) || document;
      if (!guard || !guard.parentNode) return;
      const parent = guard.parentNode;
      const isDivParent = parent.nodeType === 1 && parent.tagName === "DIV";
      const isFirstChildGuard = parent.firstElementChild === guard;
      let targetP = null;
      if (isDivParent && isFirstChildGuard) {
        targetP = doc.createElement("p");
        targetP.innerHTML = "<br>";
        parent.insertBefore(targetP, guard);
      } else {
        const prevEl = guard.previousElementSibling;
        if (
          prevEl &&
          prevEl.tagName === "P" &&
          !prevEl.classList.contains("rte-guard")
        ) {
          targetP = prevEl;
        }
      }
      const r = doc.createRange();
      const sel = doc.getSelection();
      if (targetP) {
        r.selectNodeContents(targetP);
        r.collapse(false);
      } else {
        const idx = Array.prototype.indexOf.call(parent.childNodes, guard);
        r.setStart(parent, idx);
        r.collapse(true);
      }
      sel.removeAllRanges();
      sel.addRange(r);
    },
    selectOnlyGuard() {
      const root = this._rteContentRoot;
      if (!root) return;
      const guard = root.querySelector(".rte-guard");
      if (!guard) return;
      const doc = root.ownerDocument || document;
      const r = doc.createRange();
      r.selectNodeContents(guard);
      const sel = doc.getSelection();
      sel.removeAllRanges();
      sel.addRange(r);
    },
    _getDocAndSel() {
      const root = this._rteContentRoot;
      if (!root) return {};
      const doc = root.ownerDocument || document;
      const sel = doc.getSelection();
      return { root, doc, sel };
    },
    _isNodeInsideRoot(node) {
      const { root } = this._getDocAndSel();
      if (!root || !node) return false;
      if (node.nodeType === 3) node = node.parentNode;
      return root.contains(node);
    },
    _isAfterGuardAfter(node) {
      const { root } = this._getDocAndSel();
      if (!root || !node) return false;
      const after = root.querySelector(".rte-guard-after");
      if (!after) return false;
      let el = node.nodeType === 3 ? node.parentElement : node;
      while (el && !/^(P|DIV|LI|H[1-6]|BLOCKQUOTE)$/i.test(el.tagName))
        el = el.parentElement;
      if (!el) el = node.nodeType === 3 ? node.parentElement : node;
      if (
        el &&
        (el.classList?.contains("rte-guard") || el.closest(".rte-guard"))
      )
        return false;
      const pos = after.compareDocumentPosition(el);
      return !!(pos & Node.DOCUMENT_POSITION_FOLLOWING);
    },
    _onSelectionChangeBounce() {
      if (this._bounceLock) return;
      const { root, sel } = this._getDocAndSel();
      if (!root || !sel || !sel.rangeCount) return;
      const anchor = sel.anchorNode;
      if (!this._isNodeInsideRoot(anchor)) return;
      if (this._isAfterGuardAfter(anchor)) {
        this._bounceLock = true;
        this.placeCaretAtGuard();
        (root.ownerDocument || document).defaultView?.requestAnimationFrame?.(
          () => {
            this._bounceLock = false;
          }
        ) || (this._bounceLock = false);
      }
    },
    selectAllBeforeGuard() {
      const root = this._rteContentRoot;
      if (!root) return;
      const doc = root.ownerDocument || document;
      const guard = root.querySelector(".rte-guard");
      const r = doc.createRange();
      if (guard) {
        r.setStart(root, 0);
        const idx = Array.prototype.indexOf.call(root.childNodes, guard);
        r.setEnd(root, idx);
      } else {
        r.selectNodeContents(root);
      }
      const sel = doc.getSelection();
      sel.removeAllRanges();
      sel.addRange(r);
    },
  },
};
</script>

<style scoped>
.text-editor-custom {
  color: var(--font-main-color);
  font-size: 14px;
  margin-bottom: 2px;
}
.text-error {
  color: red;
}
::v-deep .error #quill-container {
  border-top: 1px;
  border-color: red;
}
.card-preview-editor {
  min-height: 350px;
  max-height: 400px;
  overflow: auto;
  position: relative;
  cursor: default;
}
.edit-detail {
  color: var(--primary-color);
  position: absolute;
  top: 10px;
  right: 10px;
  text-decoration: underline;
  font-size: 16px;
  cursor: pointer;
  z-index: 2;
}
.content-empty {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(245, 245, 245, 0.24);
  z-index: 1;
}
::v-deep .rte-modern.rte-desktop.rte-toolbar-default {
  min-width: unset;
}
::v-deep rte-content {
  min-height: 300px;
  max-height: calc(30vh - 91px);
}

::v-deep .rte-guard [data-rte-keeper],
::v-deep .rte-guard-after [data-rte-keeper] {
  pointer-events: none;
  user-select: none;
}
</style>
